export default "__VITE_ASSET__kT69C3$a__"